import _hasIn from 'lodash/hasIn';
import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformKeysToCamelCase } from 'helpers/core';
import URLS from 'constants/urls';
import { transformAvailabilityDataToEntityShape } from 'features/ManageServices/ManageServices.helpers';
import { transformResourceData } from 'features/ManageServices/Resources/Resources.helpers';

const get = (httpClient, venueId) => {
  return httpClient
    .get(URLS.manageServices.resources.list(venueId))
    .then(response => response.data.data)
    .then(transformKeysToCamelCase)
    .then(transformAvailabilityDataToEntityShape);
};

const put = (httpClient, venueId, data) => {
  const { id, ...restData } = data;
  const endpoint = URLS.manageServices.resources.update(venueId, id);
  return httpClient.put(endpoint, transformResourceData(restData));
};

const handler = ({ httpClient }, venueId, resourceData) => {
  let promise = Promise.resolve();
  if (_hasIn(resourceData, 'id')) {
    promise = put(httpClient, venueId, resourceData);
  }

  return promise.then(() => get(httpClient, venueId));
};

export default makeEntityScaffold('SAGA.API.FETCH_RESOURCES', handler, { defaultKey: 1 });
